import { TravellerSummary } from '@/services/BookingService.interface'

const normalizeName = (value: string | null | undefined): string =>
  (value ?? '').trim().toLowerCase()

/**
 * Maps a client traveller payload to the canonical id from a fresh booking snapshot.
 * Handles stale funnel composite ids when first/last name still match.
 */
export function resolveTravellerId(
  updates: TravellerSummary,
  freshTravellers: TravellerSummary[]
): number {
  const byId = freshTravellers.find(traveller => traveller.id === updates.id)
  if (byId) return byId.id

  const byName = freshTravellers.filter(
    traveller =>
      normalizeName(traveller.firstName) === normalizeName(updates.firstName) &&
      normalizeName(traveller.lastName) === normalizeName(updates.lastName)
  )

  if (byName.length === 1) return byName[0].id

  throw new Error('Failed to update traveller.')
}
